<div [ngClass]="getLayoutClasses()" coreFreshdeskButton class="" >
    <ng-template #loading>
        <core-loader-fisherman></core-loader-fisherman>
    </ng-template>

    <ng-container *ngIf="accessChecked; else loading">
        <div class="grid-wrapper" *ngIf="accessDenied || session != null; else loading">
            <app-layout-overlapped-main *ngIf="!accessDenied"></app-layout-overlapped-main>

            <div class="head" coreFreshdeskButton [user]="session?.current?.user">
                <core-layout-header *ngIf="!accessDenied" 
                    [session]="session" 
                    [accountSession]="accountSession">
                </core-layout-header>
            </div>

            <section class="main-section">
                <core-helpers-box-http-error *ngIf="accessDenied; else routedContent"
                    [code]="403" 
                    message="You do not have access to this app.">
                </core-helpers-box-http-error>
                <ng-template #routedContent>
                    <router-outlet></router-outlet>
                </ng-template>
            </section>

            <aside class="pin_navigation" *ngIf="!accessDenied"></aside>

            <div class="foot">
                <core-layout-footer *ngIf="!accessDenied"></core-layout-footer>
            </div>
        </div>
    </ng-container>
    <app-disconnected *ngIf="!logged"></app-disconnected>
    <div class="load-block" [ngClass]="{online: logged && session!=null}"></div>
</div>
